import OnvoBase from "@/base";
import { OnvoIntegrationTables } from "../integration_tables/index.js";

export class OnvoIntegration extends OnvoBase {
    tables: OnvoIntegrationTables;

    constructor(id: string, apiKey: string, options?: { endpoint: string }) {
        super(apiKey, options);
        this.tables = new OnvoIntegrationTables(id, apiKey, options);
    }
}